module.exports = "pegasus_template/assets/tech/webinar/101.png";